import { render, staticRenderFns } from "./BarChartVis.vue?vue&type=template&id=653f2668&scoped=true&"
import script from "./BarChartVis.vue?vue&type=script&lang=js&"
export * from "./BarChartVis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f2668",
  null
  
)

export default component.exports